function AlertService($rootScope, ErrorService, $timeout, $translate) {
    'ngInject';

    $rootScope.alerts = [];

    /***
     * @ngdoc method
     * @name titleLookup
     * @methodOf BB:Alert
     * @description
     * Title look up in according of type and title parameters
     *
     * @returns {boolean} The returned title
     */
    const titleLookup = function (type, title) {
        if (title) {
            return title;
        }
        switch (type) {
            case 'error':
            case 'danger':
                title = $translate.instant('CORE.ERROR_HEADING');
                break;
            default:
                title = null;
        }
        return title;
    };

    const add = (type, {title, msg, persist}) => {
        if (persist == null) {
            persist = true;
        }
        $rootScope.alerts = [];
        const alert = {
            type,
            title: titleLookup(type, title),
            msg,
            close() {
                return alertService.closeAlert(this);
            }
        };
        $rootScope.alerts.push(alert);
        if (!persist) {
            $timeout(() => $rootScope.alerts.splice($rootScope.alerts.indexOf(alert), 1)
                , 3000);
        }
        return $rootScope.$broadcast('alert:raised');
    };


    /***
     * @ngdoc method
     * @name closeAlert
     * @methodOf BB:Alert
     * @description
     * Close alert
     *
     * @returns {boolean}  close alert
     */
    const closeAlert = (alert) => {
        return closeAlertIdx($rootScope.alerts.indexOf(alert));
    };

    /***
     * @ngdoc method
     * @name closeAlertIdx
     * @methodOf BB:Alert
     * @description
     * Close alert index
     *
     * @returns {boolean}  The returned close alert index
     */
    const closeAlertIdx = (index) => {
        return $rootScope.alerts.splice(index, 1);
    };

    /***
     * @ngdoc method
     * @name clear
     * @methodOf BB:Alert
     * @description
     * Clear alert message
     *
     * @returns {array} Newly clear array of the alert messages
     */
    const clear = () => {
        return $rootScope.alerts = [];
    };

    /***
     * @ngdoc error
     * @name clear
     * @methodOf BB:Alert
     * @description
     * Error alert
     *
     * @returns {array} The returned error alert
     */
    const error = (alert) => {
        if (!alert) {
            return;
        }

        return add('error', {title: alert.title, msg: alert.msg, persist: alert.persist});
    };

    /***
     * @ngdoc error
     * @name danger
     * @methodOf BB:Alert
     * @description
     * Danger alert
     *
     * @returns {array} The returned danger alert
     */
    const danger = (alert) => {
        if (!alert) {
            return;
        }

        return add('danger', {title: alert.title, msg: alert.msg, persist: alert.persist});
    };

    /***
     * @ngdoc error
     * @name info
     * @methodOf BB:Alert
     * @description
     * Info alert
     *
     * @returns {array} The returned info alert
     */
    const info = (alert) => {
        if (!alert) {
            return;
        }
        return add('info', {title: alert.title, msg: alert.msg, persist: alert.persist});
    };

    /***
     * @ngdoc error
     * @name warning
     * @methodOf BB:Alert
     * @description
     * Warning alert
     *
     * @returns {array} The returned warning alert
     */
    const warning = (alert) => {
        if (!alert) {
            return;
        }
        return add('warning', {title: alert.title, msg: alert.msg, persist: alert.persist});
    };


    /***
     * @ngdoc error
     * @name success
     * @methodOf BB:Alert
     * @description
     * Success alert
     *
     * @returns {array} The returned warning alert
     */
    const success = (alert) => {
        if (!alert) {
            return;
        }
        return add('success', {title: alert.title, msg: alert.msg, persist: alert.persist});
    };


    /***
     * @ngdoc error
     * @name raise
     * @methodOf BB:Alert
     * @description
     * Raise alert
     *
     * @returns {array} The returned raise alert
     */
    const raise = (key, translationValue) => {
        if (!key) return;
        const alert = ErrorService.getAlert(key, translationValue);

        if (alert) {
            return add(alert.type, {title: alert.title, msg: alert.msg, persist: alert.persist});
        }
    };

    return {
        add,
        closeAlert,
        closeAlertIdx,
        clear,
        error,
        danger,
        info,
        warning,
        success,
        raise
    };
}

angular
    .module('BB')
    .service('AlertService', AlertService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/alert.service.js